import { hFetch } from './hFetch';

type ChecklistType = 'onboarding' | 'offboarding' | 'training';

export const getTaskChecklists = async (type: ChecklistType) => {
  return await hFetch({ url: `/api/task_checklists?checklist_type=${type}` });
};

export const createTaskChecklist = async (newChecklist: TaskChecklist) => {
  return await hFetch({ url: '/api/task_checklists', method: 'POST', payload: { task_checklist: newChecklist } });
};

export const updateTaskChecklist = async (id: number, name: string) => {
  return await hFetch({ url: `/api/task_checklists/${id}`, method: 'PATCH', payload: { task_checklist: { name } } });
};

export const deleteTaskChecklist = async (id: number) => {
  return await hFetch({ url: `/api/task_checklists/${id}`, method: 'DELETE' });
};

type TaskChecklist = {
  checklist_typ: ChecklistType;
  name: string;
  primary_user_role: string;
};
